import React, { useState, useEffect } from 'react';
import { markdownToHtml } from '../../utils/markdownToHtml';
import { taiHuongDan } from '../../utils/huongDan';

/**
 * Reusable Guide button + popup modal.
 * Usage: <GuideButton slug="huong-dan-kho-hang" />
 *   nhan: chữ trên nút + tiêu đề popup (mặc định "Hướng dẫn")
 *   noiBat: tab to full chiều ngang, nền xanh thương hiệu, 👉 — khi bài hướng dẫn là thứ phải bấm vào (Combo: "Tại sao phải bán combo")
 */
const GuideButton = ({ slug, nhan = 'Hướng dẫn', noiBat = false }) => {
  const [showGuide, setShowGuide] = useState(false);
  const [guideContent, setGuideContent] = useState('');

  // Nạp sẵn khi vào trang → bấm là hiện ngay (trước đây bấm mới tải: API + file .md → chờ 1–2 giây)
  useEffect(() => { let song = true; if (slug) taiHuongDan(slug).then((t) => song && setGuideContent(t)); return () => { song = false; }; }, [slug]);
  if (!slug) return null;

  const handleOpen = () => setShowGuide(true);

  return (
    <>
      {noiBat ? (
        <button type="button" onClick={handleOpen}
                className="w-full flex items-center gap-2.5 px-4 py-3.5 rounded-2xl text-left text-white shadow-[0_4px_14px_rgba(30,90,53,.35)] active:scale-[.98] transition-transform"
                style={{ background: 'linear-gradient(135deg, #1E5A35 0%, #2E8B57 100%)' }}>
          <span className="text-[24px] leading-none">👉</span>
          <span className="flex-1 text-[16px] font-extrabold leading-tight">{nhan}</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6" /></svg>
        </button>
      ) : (
      <button
        onClick={handleOpen}
        className="flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium transition-colors ml-auto"
        style={{ color: '#f59e0b', background: '#fef3c7' }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
        </svg>
        <span>{nhan}</span>
      </button>
      )}

      {showGuide && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 animate-fade-in" onClick={() => setShowGuide(false)}>
          <div className="bg-white rounded-2xl w-full max-w-md max-h-[80vh] overflow-hidden flex flex-col animate-slide-up" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
              <h3 className="text-sm font-bold text-gray-800">📖 {nhan}</h3>
              <button onClick={() => setShowGuide(false)} className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6 6 18" /><path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
            <div
              className="huong-dan flex-1 overflow-y-auto overflow-x-hidden px-4 py-3 text-[13px] text-gray-700 leading-normal"
              dangerouslySetInnerHTML={{ __html: guideContent ? markdownToHtml(guideContent) : 'Đang tải...' }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GuideButton;
